import React, { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { Navigate, useParams, } from "react-router-dom";
import { XIcon, } from "@heroicons/react/outline";
import { CheckCircleIcon, MinusIcon, PlusSmIcon as PlusSmIconSolid, } from "@heroicons/react/solid";
import axios from "axios";

class Editcustomermodal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebarOpen: false,
            setSidebarOpen: false,
            showmsg: false,
            logoutRedirect: false,
            customer_type_id: "",
            primary_contact_salutation_id: "",
            primary_contact_first_name: "",
            primary_contact_last_name: '',
            customer_display_name: "",
            customer_gender_id: "",
            customer_date_of_birth: "",
            customer_house_number_id: "",
            customer_email: "",
            customer_work_phone: "",
            customer_mobile: "",
            customer_primary_contact_status: 0,
            customer_blood_group_id: '',
            profession_id: "",
            billing_attention: "",
            billing_country_region_id: 101,
            billing_address_street_one: "",
            billing_address_street_two: "",
            billing_city: "",
            billing_state_id: "",
            billing_zip_code: "",
            billing_phone: "",
            contact_person: [
                {
                    contact_person_first: "",
                    contact_person_gender_id: "",
                    contact_person_date_of_birth: "",
                    contact_person_relationship_id: "",
                    contact_person_mobile: "",
                }

            ],
            customer_salutation_list: [],
            customer_gender_list: [],
            customer_profession_list: [],
            customer_house_number_list: [],
            customer_type_list: [],
            customer_country_list: [],
            customer_state_list: [],
            customer_relation_list: [],
            customer_item_list: [],
            customer_blood_group_list: [],
            password: [],
            error_list: [],
            loader: "",
            overLay: "fixed inset-0 bg-black/50 ",
            editid: this.props.CustomerId,
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
        };
    }

    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };

    close = async (e) => {
        this.setState({ sidebarOpen: false });
    };
    open = async (e) => {
        this.setState({ sidebarOpen: true });
    };

    componentDidMount() {
        this.getDataForView();
    }


    async getDataForView() {
        try {
            this.setLoaderFunction();
            this.state.contact_person = [];
            const token = localStorage.getItem("token");
            const [
                { data: edit },
                { data: states },
                { data: create },
            ] = await Promise.all([
                axios.get("api/customer/edit/" + this.state.editid, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
                axios.get("api/states/" + this.state.billing_country_region_id, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
                axios.get("api/customer/url/create", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
            ]);
            this.state.contact_person = [];
            this.setState({
                customer_type_id: edit.customer_basic_detail.customer_type_id,
                primary_contact_salutation_id: edit.customer_basic_detail.primary_contact_salutation_id,
                primary_contact_first_name: edit.customer_basic_detail.primary_contact_first_name,
                primary_contact_last_name: edit.customer_basic_detail.primary_contact_last_name,
                customer_display_name: edit.customer_basic_detail.customer_display_name,
                customer_email: edit.customer_basic_detail.customer_email,
                customer_work_phone: edit.customer_basic_detail.customer_work_phone,
                customer_mobile: edit.customer_basic_detail.customer_mobile,
                customer_gender_id: edit.customer_basic_detail.customer_gender_id,
                customer_date_of_birth: edit.customer_basic_detail.customer_date_of_birth,
                customer_house_number_id: edit.customer_basic_detail.customer_house_number_id,
                customer_blood_group_id: edit.customer_basic_detail.customer_blood_group_id,
                profession_id: edit.customer_basic_detail.profession_id,
                customer_primary_contact_status: edit.customer_basic_detail.customer_primary_contact_status,
                item_id: edit.customer_basic_detail.item_id,
                billing_attention: edit.customer_basic_detail.customer_address?.billing_attention,
                billing_country_region: edit.customer_basic_detail.customer_address?.billing_country_region,
                billing_address_street_one: edit.customer_basic_detail.customer_address?.billing_address_street_one,
                billing_address_street_two: edit.customer_basic_detail.customer_address?.billing_address_street_two,
                billing_city: edit.customer_basic_detail.customer_address?.billing_city,
                billing_state_id: edit.customer_basic_detail.customer_address?.billing_state_id,
                billing_zip_code: edit.customer_basic_detail.customer_address?.billing_zip_code,
                billing_phone: edit.customer_basic_detail.customer_address?.billing_phone,
                contact_person: edit.customer_basic_detail.contact_people,
                error_list: [],
            });
            this.setState({ customer_state_list: states.states });

            this.setState({
                customer_gender_list: create.customer_genders,
                customer_salutation_list: create.salutations,
                customer_profession_list: create.customer_professions,
                customer_type_list: create.customer_types,
                customer_house_number_list: create.house_numbers,
                customer_country_list: create.countries,
                customer_relation_list: create.customer_relationship,
                customer_item_list: create.items,
                customer_blood_group_list: create.bloodGroup,
            });
            this.closeLoaderFuncion();

        } catch (error) {
            console.error("Error fetching data: ", error);
            this.enableTryAgain()
        }
    }



    tryAgain = () => {

        this.getDataForView()

    }


    handleInput = (e) => {
        const token = localStorage.getItem("token");

        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleResponse = (e) => {
        this.props.handleInputFormodal(e);
    };


    handleInputPrimaryContact = (e) => {
        this.state.customer_primary_contact_status = !this.state.customer_primary_contact_status ? (1) : (0);
        this.setState({ customer_primary_contact_status: this.state.customer_primary_contact_status });
    }

    updateCustomer = async (e) => {
        this.setLoaderFunction();
        e.preventDefault();


        var token = localStorage.getItem("token");
        const headers = {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
        };
        //const { id } = this.props.params;
        const { id } = this.state.editid;
        const res = await axios.post(
            "api/customer/update/" + this.state.editid,
            this.state,
            { headers }
        );

        if (res.data.success) {
            this.handleResponse(res.data.success);
            this.closeLoaderFuncion();
            this.setState({ showmsg: true });

            setTimeout(
                function () {
                    //Start the timer
                    this.setState({ redirect: true }); //After 1 second, set render to true
                }.bind(this),
                1000
            );
        } else {
            this.closeLoaderFuncion();
            this.setState({ error_list: res.data.data });
            //this.setState({ show: true })
        }
    };

    deletecontact = (index) => async (e) => {
        let getId = this.state.contact_person[index]["customer_contact_person_id"];

        if (getId !== undefined) {
            this.state.contact_persondelete.push({
                id: getId,
            });
        }
        this.state.contact_person = this.state.contact_person.filter(
            (s, sidx) => index !== sidx
        );

        this.setState({
            contact_person: this.state.contact_person,
        });
    };
    addperson = (e) => {
        this.setState({
            contact_person: this.state.contact_person.concat([
                {
                    contact_person_first: "",
                    contact_person_gender_id: "",
                    contact_person_date_of_birth: "",
                    contact_person_relationship_id: "",
                    contact_person_mobile: "",
                },
            ]),
        });
    };

    handleInputcontactpersonName = (index) => (e) => {
        this.state.contact_person[index].contact_person_first = e.target.value;
        this.setState({ contact_person: this.state.contact_person });
    };
    handleInputcontactpersonGender = (index) => (e) => {
        this.state.contact_person[index].contact_person_gender_id = e.target.value;
        this.setState({ contact_person: this.state.contact_person });
    };
    handleInputcontactpersonrelation = (index) => (e) => {
        this.state.contact_person[index].contact_person_relationship_id = e.target.value;
        this.setState({ contact_person: this.state.contact_person });
    };
    handleInputcontactpersonBloodGroup = (index) => (e) => {
        this.state.contact_person[index].contact_person_blood_group_id =
            e.target.value;
        this.setState({ contact_person: this.state.contact_person });
    }
    handleInputcontactpersonrelationShip = (index) => (e) => {
        this.state.contact_person[index].contact_person_relationship_id =
            e.target.value;
        this.setState({ contact_person: this.state.contact_person });

    }
    handleInputcontactpersonDob = (index) => (e) => {
        this.state.contact_person[index].contact_person_date_of_birth =
            e.target.value;
        this.setState({ contact_person: this.state.contact_person });
    };
    handleInputcontactpersonPhone = (index) => (e) => {
        this.state.contact_person[index].contact_person_mobile = e.target.value;
        this.setState({ contact_person: this.state.contact_person });
    };


    //Logout function

    logout = async (e) => {
        e.preventDefault();
        var token = localStorage.getItem("token");

        const res = await axios.get("public/api/logout", {
            headers: {
                authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        });
        if (res.data.success) {
            localStorage.removeItem("token");

            //Start the timer
            this.setState({ logoutRedirect: true }); //After 1 second, set render to true
        }
    };

    //Logout function
    contactec(error_list, index) {
        var pea = `contact_person.${index}.contact_person_email_address`;
        return error_list[pea];
    }


    render() {
        let token = localStorage.getItem("token");

        if (token == null) {
            return <Navigate to={"/Login"} />;
        }

        if (this.state.logoutRedirect) {
            return <Navigate to={"/Login"} />;
        }

        if (this.state.redirect) {
            return <Navigate to={"/Customerlist"} />;
        }

        return (
            <>
                {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-100">
            <body class="h-full">
            ```
          */}
                <div>
                    <div aria-hidden="true" />

                    {this.state.loader_status && (
                        <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                            <div className="bg-white p-4 rounded-md">
                                <div className="flex items-center justify-center">
                                    <div
                                        className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                                </div>
                                <p className="text-center mt-4">Loading...</p>
                            </div>
                        </div>
                    )}
                    {/*loader_status------------------------------------------------------------------------*/}

                    {/*try_again_status-----------------------------------------------------------------------------*/}
                    {this.state.try_again_status && (
                        <div className="h-screen flex items-center justify-center bg-white ">
                            <div className="flex flex-col items-center justify-center h-full">
                                <p className="text-red-500">{this.state.error_customize}</p>
                                <button
                                    type="button"
                                    onClick={this.tryAgain}
                                    className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                    TryAgain
                                </button>
                            </div>
                        </div>
                    )}
                    {/*try_again_status-----------------------------------------------------------------------------*/}

                    {this.state.main_content_status && (

                        <div className="flex flex-col flex-1">
                            <main className="flex-1">
                                <div className="py-6">
                                    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                        <h1 className="text-2xl font-semibold text-gray-900">
                                            Update Member
                                        </h1>
                                    </div>
                                    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                        {/* Replace with your content */}

                                        <div className="hidden sm:block" aria-hidden="true">
                                            <div className="py-5">
                                                <div className="border-t border-gray-200" />
                                            </div>
                                        </div>
                                        <div className="mt-10 sm:mt-0">
                                            <div className="md:grid md:gap-6">
                                                <div className="mt-5 md:mt-0 md:col-span-2">
                                                    <form onSubmit={this.updateCustomer}>
                                                        <div className="shadow overflow-hidden sm:rounded-md">
                                                            <div className="px-4 py-5 bg-white sm:p-6">
                                                                <div className="grid grid-cols-6 gap-6">
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="primary_contact_salutation_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Salutation
                                                                        </label>
                                                                        <select
                                                                            id="primary_contact_salutation_id"
                                                                            name="primary_contact_salutation_id"
                                                                            value={this.state.primary_contact_salutation_id ||''}
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                           
                                                                        >
                                                                            <option value=''>------</option>
                                                                            {this.state.customer_salutation_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="primary_contact_salutation_id-error"
                                                                        >
                                                                            {
                                                                                this.state.error_list
                                                                                    .primary_contact_salutation_id
                                                                            }
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="first-name"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            First Name
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="primary_contact_first_name"
                                                                            value={this.state.primary_contact_first_name ||''}
                                                                            id="first-name"
                                                                            autoComplete="given-name"
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />

                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {
                                                                                this.state.error_list
                                                                                    .primary_contact_first_name
                                                                            }
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="last-name"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Last Name
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="primary_contact_last_name"
                                                                            value={this.state.primary_contact_last_name ||''}
                                                                            id="last-name"
                                                                            autoComplete="family-name"
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {
                                                                                this.state.error_list
                                                                                    .primary_contact_last_name
                                                                            }
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_gender_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Gender
                                                                        </label>
                                                                        <select
                                                                            id="customer_gender_id"
                                                                            value={this.state.customer_gender_id ||''}
                                                                            name="customer_gender_id"
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                            
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_gender_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="customer_gender_id-error"
                                                                        >
                                                                            {
                                                                                this.state.error_list
                                                                                    .customer_gender_id
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_date_of_birth"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            <span
                                                                                className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                                                                Date of birth
                                                                            </span>
                                                                        </label>
                                                                        <input
                                                                            type="date"
                                                                            name="customer_date_of_birth"
                                                                            value={this.state.customer_date_of_birth ||''}
                                                                            id="customer_date_of_birth"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="given-name"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="customer_date_of_birth-error"
                                                                        >
                                                                            {this.state.error_list.customer_date_of_birth}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_house_number_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            <span
                                                                                className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                                                                House Number
                                                                            </span>
                                                                        </label>
                                                                        <select
                                                                            id="customer_house_number_id"
                                                                            value={this.state.customer_house_number_id ||''}
                                                                            name="customer_house_number_id"
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                           
                                                                        >
                                                                            <option value="0">------</option>
                                                                            {this.state.customer_house_number_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.house_number}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="customer_house_number_id-error"
                                                                        >
                                                                            {this.state.error_list.customer_house_number_id}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_type_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            {" "}
                                                                            <span
                                                                                className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                                                                Member Type
                                                                            </span>
                                                                        </label>
                                                                        <select
                                                                            id="customer_type_id"
                                                                            name="customer_type_id"
                                                                            value={this.state.customer_type_id ||''}
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                           
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_type_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="customer_type_id-error"
                                                                        >
                                                                            {this.state.error_list.customer_type_id}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="profession_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Profession
                                                                        </label>
                                                                        <select
                                                                            id="profession_id"
                                                                            value={this.state.profession_id ||''}
                                                                            name="profession_id"
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                           
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_profession_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="profession_id-error"
                                                                        >
                                                                            {this.state.error_list.profession_id}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_blood_group_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Blood Group
                                                                        </label>
                                                                        <select
                                                                            id="customer_blood_group_id"
                                                                            name="customer_blood_group_id"
                                                                            value={this.state.customer_blood_group_id ||''}
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                            
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_blood_group_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="customer_blood_group_id-error"
                                                                        >
                                                                            {this.state.error_list.customer_blood_group_id}
                                                                        </p>
                                                                    </div>


                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_mobile"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Phone
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            name="customer_mobile"
                                                                            value={this.state.customer_mobile ||''}
                                                                            id="customer_mobile"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="customer_mobile"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.customer_mobile}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_email"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Email
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="customer_email"
                                                                            value={this.state.customer_email ||''}
                                                                            id="customer_email"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="email"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.customer_email}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="item_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Pay Type
                                                                        </label>
                                                                        <select
                                                                            id="item_id"
                                                                            name="item_id"
                                                                            value={this.state.item_id ||''}
                                                                            onChange={this.handleInput}
                                                                            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                           
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_item_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="item_id-error"
                                                                        >
                                                                            {this.state.error_list.item_id}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="customer_primary_contact_status"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Primary Contact
                                                                        </label>

                                                                        <input
                                                                            id="customer_primary_contact_status"
                                                                            value={this.state.customer_primary_contact_status ||''}
                                                                            onChange={this.handleInputPrimaryContact}
                                                                            aria-describedby="offers-description"
                                                                            name="customer_primary_contact_status"
                                                                            checked={
                                                                                this.state.customer_primary_contact_status
                                                                            }
                                                                            type="checkbox"
                                                                            className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="customer_primary_contact_status-error"
                                                                        >
                                                                            {this.state.error_list.customer_primary_contact_status}
                                                                        </p>

                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="password"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Password
                                                                        </label>
                                                                        <input
                                                                            type="password"
                                                                            name="password"
                                                                            id="password"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="password"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="password-error"
                                                                        >
                                                                            {this.state.error_list.password}
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                                                        <div>
                                                                            <h3 className="text-lg leading-6 font-medium text-gray-900">
                                                                                ADDRESS
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-3">
                                                                        <label
                                                                            htmlFor="street-address"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Attention
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="billing_attention"
                                                                            value={this.state.billing_attention ||''}
                                                                            id="Attention"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="street-address"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.billing_attention}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-3">
                                                                        <label
                                                                            htmlFor="billing_country_region"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Country / Region
                                                                        </label>
                                                                        <select
                                                                            id="billing_country_region"
                                                                            disabled
                                                                            name="billing_country_region"
                                                                            value={this.state.billing_country_region_id ||''}
                                                                            onChange={this.handleInput}

                                                                            autoComplete="country-name"
                                                                            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_country_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.billing_country_region}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="city"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Address Street 1
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="billing_address_street_one"
                                                                            value={this.state.billing_address_street_one ||''}
                                                                            id="Street_address"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="address-level2"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.Street_address}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="city"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Address Street 2
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="billing_address_street_two"
                                                                            value={this.state.billing_address_street_two ||''}
                                                                            id="Street_address2"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="address-level2"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.Street_address2}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="city"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            City
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            name="billing_city"
                                                                            value={this.state.billing_city ||''}
                                                                            onChange={this.handleInput}
                                                                            id="city"
                                                                            autoComplete="address-level2"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.billing_city}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="billing_state_id"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            State / Province
                                                                        </label>

                                                                        <select
                                                                            id="state"
                                                                            name="billing_state_id"
                                                                            value={this.state.billing_state_id ||''}
                                                                            onChange={this.handleInput}
                                                                            autoComplete="billing_state_id"
                                                                            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                        >
                                                                            <option value="">------</option>
                                                                            {this.state.customer_state_list.map((number, index) => (
                                                                                <option key={index} value={number.id}>
                                                                                    {number.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        
                                                                        <p
                                                                                className="mt-2 text-sm text-red-600"
                                                                                id="billing_state_id-error"
                                                                            >
                                                                                {this.state.error_list.billing_state_id}
                                                                            </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="postal-code"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Zip Code
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            value={this.state.billing_zip_code ||''}
                                                                            name="billing_zip_code"
                                                                            onChange={this.handleInput}
                                                                            id="postal-code"
                                                                            autoComplete="postal-code"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.billing_zip_code}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                                                        <label
                                                                            htmlFor="billing_phone"
                                                                            className="block text-sm font-medium text-gray-700"
                                                                        >
                                                                            Mobile
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            name="billing_phone"
                                                                            value={this.state.billing_phone ||''}
                                                                            id="billing_phone"
                                                                            onChange={this.handleInput}
                                                                            autoComplete="address-level1"
                                                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                        />
                                                                        <p
                                                                            className="mt-2 text-sm text-red-600"
                                                                            id="email-error"
                                                                        >
                                                                            {this.state.error_list.billing_phone}
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                                                    <div>
                                                                        <h4 className="text-lg leading-6 font-medium text-gray-900">
                                                                            Contact Person Details
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                                <hr />
                                                                <div className="mt-8">
                                                                    {this.state.contact_person.map(
                                                                        (person, index) => (
                                                                            <div key={index} className="grid grid-cols-6 gap-6">
                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <label
                                                                                        htmlFor="contact_person_first"
                                                                                        className="block text-sm font-medium text-gray-700"
                                                                                    >
                                                                                        Name
                                                                                    </label>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="contact_person_first"
                                                                                        onChange={this.handleInputcontactpersonName(
                                                                                            index
                                                                                        )}
                                                                                        value={person.contact_person_first ||''}
                                                                                        id="contact_person_first"
                                                                                        autoComplete="address-level2"
                                                                                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                                    />
                                                                                    <p
                                                                                        className="mt-2 text-sm text-red-600"
                                                                                        id="contact_person_first-error"
                                                                                    >
                                                                                        {
                                                                                            this.contactec(this.state.error_list, index)

                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <label
                                                                                        htmlFor="contact_person_gender_id"
                                                                                        className="block text-sm font-medium text-gray-700"
                                                                                    >
                                                                                        Gender
                                                                                    </label>
                                                                                    <select
                                                                                        id="contact_person_gender_id"
                                                                                        name="contact_person_gender_id"
                                                                                        onChange={this.handleInputcontactpersonGender(index)}
                                                                                        value={person.contact_person_gender_id ||''}
                                                                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                                       
                                                                                    >
                                                                                        <option value="">------</option>
                                                                                        {this.state.customer_gender_list.map((number, index) => (
                                                                                            <option key={index} value={number.id}>
                                                                                                {number.name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    <p
                                                                                        className="mt-2 text-sm text-red-600"
                                                                                        id="contact_person_gender_id-error"
                                                                                    >
                                                                                        {

                                                                                            this.contactec(this.state.error_list, index)

                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <label
                                                                                        htmlFor="contact_person_date_of_birth"
                                                                                        className="block text-sm font-medium text-gray-700"
                                                                                    >
                                                                                        DOB
                                                                                    </label>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="contact_person_date_of_birth"

                                                                                        onChange={this.handleInputcontactpersonDob(
                                                                                            index
                                                                                        )}
                                                                                        value={person.contact_person_date_of_birth ||''}
                                                                                        id="contact_person_date_of_birth"
                                                                                        autoComplete="address-level2"
                                                                                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                                    />
                                                                                    <p
                                                                                        className="mt-2 text-sm text-red-600"
                                                                                        id="contact_person_date_of_birth-error"
                                                                                    >
                                                                                        {

                                                                                            this.contactec(this.state.error_list, index)

                                                                                        }
                                                                                    </p>
                                                                                </div>

                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <label
                                                                                        htmlFor="contact_person_blood_group_id"
                                                                                        className="block text-sm font-medium text-gray-700"
                                                                                    >
                                                                                        Blood Group
                                                                                    </label>
                                                                                    <select
                                                                                        id="contact_person_blood_group_id"
                                                                                        name="contact_person_blood_group_id"
                                                                                        onChange={this.handleInputcontactpersonBloodGroup(index)}
                                                                                        value={person.contact_person_blood_group_id ||''}
                                                                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                                       
                                                                                    >
                                                                                        <option value="">------</option>
                                                                                        {this.state.customer_blood_group_list.map((number, index) => (
                                                                                            <option key={index} value={number.id}>
                                                                                                {number.name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    <p
                                                                                        className="mt-2 text-sm text-red-600"
                                                                                        id="contact_person_blood_group_id-error"
                                                                                    >
                                                                                        {this.state.error_list.contact_person_blood_group_id}
                                                                                    </p>
                                                                                </div>
                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <label
                                                                                        htmlFor="contact_person_relationship_id"
                                                                                        className="block text-sm font-medium text-gray-700"
                                                                                    >
                                                                                        Relationship
                                                                                    </label>
                                                                                    <select
                                                                                        id="contact_person_relationship_id"
                                                                                        value={person.contact_person_relationship_id ||''}
                                                                                        name="contact_person_relationship_id"
                                                                                        onChange={this.handleInputcontactpersonrelation(index)}
                                                                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                                                                       
                                                                                    >
                                                                                        <option value="">------</option>
                                                                                        {this.state.customer_relation_list.map((number, index) => (
                                                                                            <option key={index} value={number.id}>
                                                                                                {number.name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    <p
                                                                                        className="mt-2 text-sm text-red-600"
                                                                                        id="contact_person_relationship_id-error"
                                                                                    >
                                                                                        {
                                                                                            this.state.error_list
                                                                                                .contact_person_relationship_id
                                                                                        }
                                                                                    </p>
                                                                                </div>
                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <label
                                                                                        htmlFor="contact_person_mobile"
                                                                                        className="block text-sm font-medium text-gray-700"
                                                                                    >
                                                                                        Phone
                                                                                    </label>
                                                                                    <input
                                                                                        type="number"
                                                                                        name="contact_person_mobile"

                                                                                        onChange={this.handleInputcontactpersonPhone(
                                                                                            index
                                                                                        )}
                                                                                        value={person.contact_person_mobile ||''}
                                                                                        id="contact_person_mobile"
                                                                                        autoComplete="address-level2"
                                                                                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                                                    />
                                                                                    <p
                                                                                        className="mt-2 text-sm text-red-600"
                                                                                        id="contact_person_mobile-error"
                                                                                    >
                                                                                        {
                                                                                            this.state.error_list
                                                                                                .contact_person_mobile
                                                                                        }
                                                                                    </p>
                                                                                </div>

                                                                                <div
                                                                                    className="col-span-6 sm:col-span-6 lg:col-span-1">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                                                        onClick={this.deletecontact(index)}
                                                                                    >
                                                                                        <MinusIcon
                                                                                            className="h-5 w-5"
                                                                                            aria-hidden="true"
                                                                                        />
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    )}{" "}
                                                                </div>
                                                                <div className="grid grid-cols-6 gap-6">
                                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                        <button
                                                                            type="button"
                                                                            className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                            onClick={this.addperson}
                                                                        >
                                                                            <PlusSmIconSolid
                                                                                className="h-5 w-5"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                                <button
                                                                    type="submit"
                                                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>

                                        {/* /End replace */}
                                    </div>
                                </div>
                            </main>
                        </div>
                    )}
                </div>

                <div
                    aria-live="assertive"
                    className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
                >
                    <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
                        {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                        <Transition
                            show={this.state.showmsg}
                            //show={true}
                            as={Fragment}
                            enter="transform ease-out duration-300 transition"
                            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div
                                className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                                <div className="p-4">
                                    <div className="flex">
                                        <div className="flex-shrink-0">
                                            <CheckCircleIcon
                                                className="h-6 w-6 text-green-400"
                                                aria-hidden="true"
                                            />
                                        </div>
                                        <div className="ml-3 w-0 flex-1 pt-0.5">
                                            <p className="text-sm font-medium text-gray-900">
                                                Successfully Saved
                                            </p>
                                            <p className="mt-1 text-sm text-gray-500"></p>
                                        </div>
                                        <div className="ml-4 flex-shrink-0 flex">
                                            <button
                                                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                onClick={() => {
                                                    this.setState({ showmsg: false });
                                                }}
                                            >
                                                <span className="sr-only">Close</span>
                                                <XIcon className="h-5 w-5" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    </div>
                </div>
            </>
        );
    }
}

export default (props) => <Editcustomermodal {...props} params={useParams()} />;
